
import Icon from '@/ui-kit/components/icon';
import Gutter from '@/ui-kit/components/gutter';
import { IconType } from '@/ui-kit/components/icon/enums';
import {
  StyleSizeType,
  StyleColorSchemeType,
  StylePositionType,
  StyleFontWeightType,
} from '@/ui-kit/styles/enums';
import LazyImage from '@/components/lazy-image';
import ImageHelper from '@/utils/ImageHelper';
import { Comparator } from '@/ui-kit/enums';
import Typography from '@/ui-kit/components/typography';
import { TypographyType } from '@/ui-kit/components/typography/enums';

export default {
  /**
   * @component Link with image component
   *
   * @public
   */

  name: 'LinkWithImageComponent',
  components: {
    Icon,
    Gutter,
    LazyImage,
    Typography,
  },
  props: {
    image: {
      type: Object,
      required: true,
    },
    title: {
      type: String,
      default: '',
    },
    link: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      IconType,
      StyleSizeType,
      StyleColorSchemeType,
      StylePositionType,
      StyleFontWeightType,
      TypographyType,
    };
  },
  computed: {
    imageRatio() {
      return ImageHelper.constructor.getImageRatio(this.image.dimensions);
    },
    imageSizes() {
      return [
        {
          comparator: Comparator.Greater,
          breakpoint: StyleSizeType.XSmall,
          imageSize: 90,
        },
      ];
    },
  },
  methods: {
    /**
     * Back button on click handler.
     *
     * @private
     */

    navigateToLink() {
      window.open(this.link);
    },
  },
};
